<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal" @submit.prevent="onSubmit">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">공지사항 등록</h4>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">카테고리</label>
                <div class="col-sm-10">
                  <el-select class="select-primary" size="large" placeholder="카테고리선택" v-model="categoryId">
                    <el-option
                      v-for="option in categories"
                      class="select-primary"
                      :value="option.id"
                      :label="option.category"
                      :key="option.category"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">타이틀</label>
                <div class="col-sm-10">
                  <base-input placeholder="타이틀" v-model="title" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <label class="col-sm-2 col-form-label">타이틀(영어)</label>
                <div class="col-sm-10">
                  <base-input placeholder="타이틀" v-model="titleEn">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <label class="col-sm-2 col-form-label">타이틀(일본어)</label>
                <div class="col-sm-10">
                  <base-input placeholder="타이틀" v-model="titleJa">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">템플릿</label>
                <div class="col-sm-10">
                  <TemplateSelect type="notice" @templateApply="applyTemplate" :show-bottom-button="true"></TemplateSelect>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">내용</label>
                <el-popover trigger="hover" placement="top">
                  <div>
                    <div class="popover-body">
                      [링크텍스트](링크URL) 입력시, 링크텍스트에 하이퍼링크가 적용됩니다<br />
                      ex) [블립](https://www.blip.kr) 입력시, 블립에 하이퍼링크 적용
                      <br /><br />
                      [텍스트 효과 안내]<br />
                      &lt;b&gt;bold&lt;/b&gt;<br />
                      &lt;i&gt;italic&lt;/i&gt;<br />
                      &lt;s&gt;strike&lt;/s&gt;<br />
                      &lt;font color="#FF0000"&gt;color&lt;/font&gt;<br />
                      * 주의사항: 컬러코드에 "" 이 따옴표를 써야 합니다.<br />
                      “” 이 따옴표를 쓰면 해당 색상 적용이 안 됩니다 <br /><br />[주요 컬러 코드]<br />
                      블립 블랙 #28211E<br />
                      블립 레드 #FF324B<br />
                      블립 그레이 (진한 색) #939191<br />
                      블립 그레이 (연한 색) #B4B0AF<br />
                      링크 컬러 #00A2F9<br />* 링크 컬러는 적용 안 해도 링크에 자동으로 해당 색상 들어갑니다<br />* 위 컬러를 메인으로 사용해주시고,<br />아티스트
                      대표색 등을 넣어야 하면 해당 컬러코드를 넣으면 됩니다.<br />* 기타 컬러 코드 정보 참고 사이트<br />
                      https://html-color-codes.info/Korean
                    </div>
                  </div>
                  <base-button slot="reference"> i </base-button>
                </el-popover>
              </div>
              <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-11">
                  <base-input placeholder="내용">
                    <textarea class="form-control" id="content" rows="30" v-model="content" />
                  </base-input>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">컨텐츠추가</label>

                <base-button @click="addContent" type="success">+</base-button>
              </div>
              <draggable class="row" handler=".handler" v-model="contents" group="people" @start="drag = true" @end="drag = false">
                <div class="col-sm-12" v-for="(content, index) in contents">
                  <div class="row">
                    <div class="col-sm-2">
                      <span v-for="(n, i) in contentTypes" :key="i">
                        <base-radio @change="onChangeContentType(index)" :name="n.type" inline v-model="content.contentType">{{ n.name }}</base-radio>
                      </span>
                    </div>

                    <div v-if="content.contentType === 'I'" class="col-sm-8">
                      <div class="row">
                        <div class="col-sm-1">KO</div>
                        <div class="col-sm-3">
                          <BlipFileUploadZone
                            :upload-category="10"
                            :index="index"
                            :maxFiles="1"
                            :fileUrl="content.imageFileId | blipImageUrl"
                            @onChangeFileIds="onMediaFileIdChange"
                          />
                        </div>
                        <div class="col-sm-1">EN</div>
                        <div class="col-sm-3">
                          <BlipFileUploadZone
                            :upload-category="10"
                            :index="index"
                            :maxFiles="1"
                            :fileUrl="content.imageFileEnId | blipImageUrl"
                            @onChangeFileIds="onMediaFileEnIdChange"
                          />
                        </div>
                        <div class="col-sm-1">JA</div>
                        <div class="col-sm-3">
                          <BlipFileUploadZone
                            :upload-category="10"
                            :index="index"
                            :maxFiles="1"
                            :fileUrl="content.imageFileJaId | blipImageUrl"
                            @onChangeFileIds="onMediaFileJaIdChange"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-8" v-if="content.contentType === 'V'">
                      <div class="row">
                        <div class="col-sm-6">
                          <BlipFileUploadZone
                            :upload-category="10"
                            :index="index"
                            :maxFiles="1"
                            :fileUrl="content.imageUrl"
                            @onChangeFileIds="onMediaFileIdChange"
                          />
                        </div>
                        <div class="col-sm-6">
                          <div class="row">
                            <label class="col-sm-2 col-form-label">URL</label>
                            <div class="col-sm-10">
                              <base-input placeholder="url" v-model="content.path">
                                <span slot="helpBlock" class="form-text" />
                              </base-input>
                            </div>
                          </div>
                          <div class="row">
                            <label class="col-sm-2 col-form-label"></label>
                            <div class="col-sm-10">
                              <base-button @click="getMetadata(content.path, index)" type="default">썸네일불러오기</base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-sm-1 col-form-label">타이틀</label>
                        <div class="col-sm-3">
                          <base-input placeholder="타이틀" v-model="content.title">
                            <span slot="helpBlock" class="form-text" />
                          </base-input>
                        </div>
                        <label class="col-sm-1 col-form-label">서브타이틀</label>
                        <div class="col-sm-3">
                          <base-input placeholder="서브타이틀" v-model="content.subtitle">
                            <span slot="helpBlock" class="form-text" />
                          </base-input>
                        </div>
                        <label class="col-sm-1 col-form-label">재생시간(초)</label>
                        <div class="col-sm-3">
                          <base-input placeholder="재생시간" v-model="content.duration">
                            <span slot="helpBlock" class="form-text" />
                          </base-input>
                        </div>
                      </div>
                    </div>

                    <div v-if="content.contentType === 'T'" class="col-sm-8">
                      <label class="col-sm-2 col-form-label">내용</label>

                      <base-input placeholder="내용">
                        <textarea class="form-control" rows="10" v-model="content.description"></textarea>
                      </base-input>
                    </div>
                    <div v-if="content.contentType === 'B'" class="col-sm-8">
                      <div class="row">
                        <label class="col-sm-2 col-form-label">타이틀</label>
                        <div class="col-sm-4">
                          <base-input placeholder="타이틀" v-model="content.title">
                            <span slot="helpBlock" class="form-text" />
                          </base-input>
                        </div>
                        <label class="col-sm-2 col-form-label">링크</label>
                        <div class="col-sm-4">
                          <base-input placeholder="링크" v-model="content.link">
                            <span slot="helpBlock" class="form-text" />
                          </base-input>
                        </div>
                      </div>
                    </div>

                    <base-button class="handler" @click="removeContent(index)" type="default">-</base-button>
                  </div>
                  <div class="row">&nbsp;</div>
                </div>
              </draggable>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">오픈시간</label>
              <div class="col-sm-4">
                <base-input>
                  <el-date-picker type="datetime" placeholder="오픈시간" v-model="openTime"></el-date-picker>
                </base-input>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">노출여부</label>
              <div class="col-sm-4">
                <base-switch v-model="isVisible" type="primary" on-text="ON" off-text="OFF" />
              </div>
              <label class="col-sm-2 col-form-label">목록노출</label>
              <div class="col-sm-4">
                <base-switch v-model="showList" type="primary" on-text="ON" off-text="OFF" />
              </div>
            </div>
          </card>
          <base-button native-type="submit" :disabled="isLoading" type="success">등록</base-button>
          <base-button v-if="noticeId" @click="deleteNotice" type="danger">삭제</base-button>
          <base-button @click="goBack" type="default">뒤로</base-button>
        </form>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
<script>
import TemplateSelect from "@/pages/Components/TemplateSelect.vue";
import { Card, BaseInput, BaseButton, BaseSwitch } from "@/components/index";
import { Toast } from "@/util/Toast";
import swal from "sweetalert2";
import { Cropper } from "vue-advanced-cropper";
import * as _ from "lodash";

import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import { showAPIErrorToast } from "../../util/ErrorUtils";

import draggable from "vuedraggable";
import { UserData } from "@/util/UserData";
import { TemplateLocation } from "@/pages/Components/TemplateSelect";
export default {
  components: {
    TemplateSelect,
    Card,
    Cropper,
    BlipFileUploadZone,
    draggable,
    BaseButton,
    BaseInput,
    BaseSwitch,
  },
  async created() {
    const me = this;
    await this.getCategories();
    if (this.$route.query.id) {
      this.noticeId = this.$route.query.id;
      await this.getNotice();
    } else {
      const content = UserData.get("noticeDetail");
      if (content?.length > 11) {
        if (confirm("임시저장된 데이터를 불러오시겠습니까?")) {
          this.content = content;
          UserData.set("noticeDetail", "");
        }
      }
    }
    setInterval(function () {
      if (me.content?.length > 11) {
        UserData.set("noticeDetail", me.content);
      }
    }, 60000); // every 60 second interval
  },
  data() {
    return {
      isLoading: null,
      categories: [],
      categoryId: null,
      noticeId: null,
      title: null,
      titleEn: null,
      titleJa: null,
      content: null,
      isVisible: true,
      showList: true,
      openTime: null,
      contents: [],
      contentTypes: [
        { type: "I", name: "이미지" },
        { type: "V", name: "비디오" },
        { type: "T", name: "텍스트" },
        { type: "B", name: "버튼" },
      ],
      ratios: [
        { value: null, label: "원본" },
        { value: 1, label: "1:1" },
        { value: 2, label: "16:9" },
        { value: 3, label: "4:3" },
        { value: 4, label: "3:4" },
        { value: 5, label: "9:16" },
      ],
      ratioValues: [
        {
          key: 1,
          value: 1,
        },
        {
          key: 2,
          value: 1.78,
        },
        {
          key: 3,
          value: 1.33,
        },
        {
          key: 4,
          value: 0.75,
        },
        {
          key: 5,
          value: 0.56,
        },
      ],
    };
  },

  methods: {
    async getCategories() {
      return this.$axios.get(`/notice/categories`, null).then((res) => {
        this.categories = res.data.data;
      });
    },
    async getNotice() {
      return this.$axios.get(`/notice/${this.noticeId}`, null).then((res) => {
        const data = res.data.data;
        this.categoryId = data.categoryId;
        this.title = data.title;
        this.titleEn = data.titles?.en;
        this.titleJa = data.titles?.ja;
        this.content = data.content;
        this.isVisible = data.isVisible === 1;
        this.showList = data.showList === 1;
        this.contents = data.contents;
        this.openTime = data.openTime;
        this.contents.map((content, index) => {
          if (content.imageFileIds) {
            content.imageFileEnId = content.imageFileIds.en;
            content.imageFileJaId = content.imageFileIds.ja;
          }
          if (content.ratio) {
            this.ratioValues.forEach((ratio) => {
              if (ratio.value === content.ratio) {
                content.ratio = ratio.key;
                content.aspectRatio = ratio.value;
              }
            });
          }
          if (content.extMetadata) {
            const extMetadata = JSON.parse(content.extMetadata);
            const me = this;
            if (content.contentType === "I") {
              setTimeout(function () {
                me.$refs["cropper" + index][0].setCoordinates(
                  {
                    width: extMetadata.display.width,
                    height: extMetadata.display.height,
                    left: extMetadata.display.x,
                    top: extMetadata.display.y,
                  },
                  1000
                );
              });
            }
          }
          return content;
        });
      });
    },
    addContent() {
      this.contents.push({ contentType: "I", ratio: null });
    },
    removeContent(index) {
      if (index !== -1) {
        this.contents.splice(index, 1);
      }
    },
    async onRatioChange(content) {
      if (content.ratio) {
        this.ratioValues.forEach((ratio) => {
          if (ratio.key === content.ratio) {
            content.aspectRatio = ratio.value;
          }
        });
      } else {
        await this.$axios.put(`/common/fileMetadata`, { fileId: content.imageFileId, extMetadata: null });
      }
    },
    onCropperChange(a, b) {
      console.log(a, b);
    },
    async cropImage(fileId, index) {
      const { coordinates } = this.$refs["cropper" + index][0].getResult();
      const display = { x: coordinates.left, y: coordinates.top, width: coordinates.width, height: coordinates.height };
      const extMetadata = { display };
      await this.$axios.put(`/common/fileMetadata`, { fileId, extMetadata });
      window.Toast.success("표시영역이 저장되었어요");
    },
    onChangeContentType(index) {
      const content = this.contents[index];
      if (content.extMetadata) {
        const extMetadata = JSON.parse(content.extMetadata);
        const me = this;
        if (content.contentType === "I") {
          setTimeout(function () {
            me.$refs["cropper" + index][0].setCoordinates(
              {
                width: extMetadata.display.width,
                height: extMetadata.display.height,
                left: extMetadata.display.x,
                top: extMetadata.display.y,
              },
              1000
            );
          });
        }
      }
    },
    onMediaFileIdChange(newFileIds, index) {
      this.contents[index].imageFileId = newFileIds[0];
    },
    onMediaFileEnIdChange(newFileIds, index) {
      this.contents[index].imageFileEnId = newFileIds[0];
    },
    onMediaFileJaIdChange(newFileIds, index) {
      this.contents[index].imageFileJaId = newFileIds[0];
    },
    getMetadata(url, index) {
      if (url === "" || url === null) {
        window.Toast.error("url을 입력해주세요");
        return;
      }
      return this.$axios.get(`/common/metadata?url=${url}`).then((res) => {
        const data = res.data.data;
        this.contents[index].imageUrl = data.image;
        this.contents[index].imageFileId = null;
        this.contents[index].path = null;
        this.contents[index].path = url;
      });
    },

    applyTemplate(data) {
      const location = data.location;
      if (location === TemplateLocation.ADD) {
        if (this.content) {
          this.content += "\n" + data.contents;
        } else {
          this.content = data.contents;
        }
      } else if (location === TemplateLocation.OVERWRITE) {
        this.content = data.contents;
      } else if (location === TemplateLocation.BOTTOM) {
        if (this.contents.length === 0) {
          Toast.error("컨텐츠가 없어요");
        } else if (_.filter(this.contents, { contentType: "T" }).length === 0) {
          Toast.error("텍스트 타입 컨텐츠가 없어요");
        } else {
          if (_.last(_.filter(this.contents, { contentType: "T" })).description) {
            _.last(_.filter(this.contents, { contentType: "T" })).description += "\n" + data.contents;
          } else {
            _.last(_.filter(this.contents, { contentType: "T" })).description = data.contents;
          }
          this.isVisible = !this.isVisible;
          this.isVisible = !this.isVisible;
        }
      }
    },

    async onSubmit() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      if (this.title === null) {
        window.Toast.error("제목을 입력해주세요");
        return;
      }
      if (this.content === null) {
        window.Toast.error("내용을 입력해주세요");
        return;
      }
      if (this.contents?.length > 0) {
        const contents = this.contents;
        for (let i = 0; i < contents.length; i++) {
          const content = contents[i];
          if (content.contentType === "I") {
            if (!content.imageFileId && !content.imageUrl) {
              window.Toast.error("컨텐츠 이미지를 등록해주세요");
              return;
            }
          } else if (content.contentType === "V") {
            if (!content.imageFileId && !content.imageUrl) {
              window.Toast.error("컨텐츠 이미지를 등록해주세요");
              return;
            }
            if (!content.path) {
              Toast.error("컨텐츠 URL을 등록해주세요");
              return;
            }
          } else if (content.contentType === "T") {
            if (!content.description || content.description === "") {
              Toast.error("컨텐츠 텍스트를 등록해주세요");
              return;
            }
          }
        }
      }
      const param = {};
      param.categoryId = this.categoryId;
      param.title = this.title;
      param.content = this.content;
      param.isVisible = this.isVisible ? 1 : 0;
      param.showList = this.showList ? 1 : 0;
      param.openTime = this.openTime;
      param.titles = { ko: this.title, en: this.titleEn, ja: this.titleJa };
      param.contents = this.contents.map((content) => {
        if (content.ratio) {
          this.ratioValues.forEach((ratio) => {
            if (ratio.key === content.ratio) {
              content.ratio = ratio.value;
            }
          });
        }
        content.imageFileIds = { ko: content.imageFileId, en: content.imageFileEnId, ja: content.imageFileJaId };

        return content;
      });
      try {
        if (this.noticeId) {
          param.noticeId = this.noticeId;
          await this.$axios.put(`/notice/${this.noticeId}`, param).then((res) => {
            Toast.success("수정되었습니다");
            history.go(-1);
          });
        } else {
          await this.$axios.post(`/notice`, param).then((res) => {
            Toast.success("등록되었습니다");
            history.go(-1);
          });
        }
      } catch (e) {
        showAPIErrorToast(e);
      }
    },

    async deleteNotice() {
      swal
        .fire({
          title: "삭제 확인",
          text: `${this.noticeId} 공지사항을 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const param = {};
              if (this.noticeId) {
                param.noticeId = this.noticeId;

                return this.$axios.delete(`/notice/${this.noticeId}`, param).then((res) => {
                  Toast.success("삭제되었습니다");
                  history.go(-1);
                });
              }
            } catch (err) {
              Toast.error("공지사항 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    goBack() {
      swal
        .fire({
          title: "확인",
          text: `정말 뒤로 가시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "뒤로",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            localStorage.setItem("noticeDetail", "");
            history.go(-1);
          }
        });
    },
  },
};
</script>
<style scoped>
textarea#content {
  max-height: 300px;
}
.bootstrap-switch {
  margin: 6px;
}
</style>
